import { render, staticRenderFns } from "./MouserProductTile.vue?vue&type=template&id=7defce78&scoped=true&lang=pug&"
import script from "./MouserProductTile.vue?vue&type=script&lang=js&"
export * from "./MouserProductTile.vue?vue&type=script&lang=js&"
import style0 from "./MouserProductTile.vue?vue&type=style&index=0&id=7defce78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7defce78",
  null
  
)

export default component.exports